import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faBell, faBars } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "./Searchbar";

const MobileHeader = ({
  isAuthenticated,
  cartCount,
  unreadCount,
  notifications,
  setIsSidebarOpen,
  setIsNotifDropdownOpen,
  onSearchSubmit,
  navigate,
  onClearAll,
  onRemoveOne,
  onSeeAll
}) => {
  const notifDropdownRef = useRef(null);

  const toggleNotifDropdown = () => {
    setIsNotifDropdownOpen(prev => !prev);
  };

  return (
    <div className="lg:hidden">
      <div className="container mx-auto">
        <div className="flex justify-between items-center p-4">
          <div 
            className="flex items-center space-x-2 cursor-pointer" 
            onClick={() => navigate("/")}
          >
            <img src="/assets/zakkuicon.png" alt="Logo" className="h-9" />
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-violet-800">
                Zakku
              </span>
              <span className="text-xs text-gray-600 -mt-1 font-medium tracking-wider">
                PREMIUM SHOPPING
              </span>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {isAuthenticated && (
              <>
                <div className="relative" title="Cart">
                  <Link to="/cart">
                    <FontAwesomeIcon icon={faShoppingCart} size="lg" />
                    {cartCount > 0 && (
                      <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
                        {cartCount}
                      </span>
                    )}
                  </Link>
                </div>
                
                <div className="relative" ref={notifDropdownRef} title="Notifications">
                  <button onClick={toggleNotifDropdown}>
                    <FontAwesomeIcon icon={faBell} size="lg" />
                    {unreadCount > 0 && (
                      <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
                        {unreadCount}
                      </span>
                    )}
                  </button>
                </div>
              </>
            )}

            <button
              onClick={() => setIsSidebarOpen(true)}
              className="text-2xl"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
        </div>

        {/* Mobile Search Bar */}
        <SearchBar isMobile={true} onSearchSubmit={onSearchSubmit} />
      </div>
    </div>
  );
};

export default MobileHeader;




// import React, { useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faShoppingCart, faBell, faBars } from "@fortawesome/free-solid-svg-icons";
// import SearchBar from "./Searchbar";

// const MobileHeader = ({
//   isAuthenticated,
//   cartCount,
//   unreadCount,
//   notifications,
//   setIsSidebarOpen,
//   setIsNotifDropdownOpen,
//   onSearchSubmit,
//   navigate,
//   onClearAll,
//   onRemoveOne,
//   onSeeAll
// }) => {
//   const notifDropdownRef = useRef(null);

//   const toggleNotifDropdown = () => {
//     setIsNotifDropdownOpen(prev => !prev);
//   };

//   return (
//     <div className="lg:hidden">
//       <div className="container mx-auto">
//         <div className="flex justify-between items-center p-4">
//           <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
//             <img src="/assets/zakkuicon.png" alt="Logo" className="h-8 cursor-pointer" />
//           </div>
          
//           <div className="flex items-center space-x-4">
//             {isAuthenticated && (
//               <>
//                 <div className="relative" title="Cart">
//                   <Link to="/cart">
//                     <FontAwesomeIcon icon={faShoppingCart} size="lg" />
//                     {cartCount > 0 && (
//                       <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
//                         {cartCount}
//                       </span>
//                     )}
//                   </Link>
//                 </div>
                
//                 <div className="relative" ref={notifDropdownRef} title="Notifications">
//                   <button onClick={toggleNotifDropdown}>
//                     <FontAwesomeIcon icon={faBell} size="lg" />
//                     {unreadCount > 0 && (
//                       <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
//                         {unreadCount}
//                       </span>
//                     )}
//                   </button>
//                 </div>
//               </>
//             )}

//             <button
//               onClick={() => setIsSidebarOpen(true)}
//               className="text-2xl"
//             >
//               <FontAwesomeIcon icon={faBars} />
//             </button>
//           </div>
//         </div>

//         {/* Mobile Search Bar */}
//         <SearchBar isMobile={true} onSearchSubmit={onSearchSubmit} />
//       </div>
//     </div>
//   );
// };

// export default MobileHeader;

// import React, { useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faShoppingCart, faBell, faBars } from "@fortawesome/free-solid-svg-icons";
// import SearchBar from "./Searchbar";

// const MobileHeader = ({
//   isAuthenticated,
//   cartCount,
//   unreadCount,
//   notifications,
//   setIsSidebarOpen,
//   onSearchSubmit,
//   navigate
// }) => {
//   const [isNotifDropdownOpen, setIsNotifDropdownOpen] = useState(false);
//   const notifDropdownRef = useRef(null);

//   const formatNotificationTime = (dateString) => {
//     try {
//       const now = new Date();
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return "Recently";
      
//       const diffInSeconds = Math.floor((now - date) / 1000);
      
//       if (diffInSeconds < 60) return "Just now";
//       if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
//       if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
//       if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`;
      
//       return date.toLocaleDateString();
//     } catch (error) {
//       return "Recently";
//     }
//   };

//   const toggleNotifDropdown = () => {
//     setIsNotifDropdownOpen(!isNotifDropdownOpen);
//   };

//   return (
//     <div className="lg:hidden">
//       <div className="container mx-auto">
//         <div className="flex justify-between items-center p-4">
//           <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
//             <img src="/assets/logo.png" alt="Logo" className="h-8 cursor-pointer" />
//           </div>
          
//           <div className="flex items-center space-x-4">
//             {isAuthenticated && (
//               <>
//                 <div className="relative" title="Cart">
//                   <Link to="/cart">
//                     <FontAwesomeIcon icon={faShoppingCart} size="lg" />
//                     {cartCount > 0 && (
//                       <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
//                         {cartCount}
//                       </span>
//                     )}
//                   </Link>
//                 </div>
                
//                 <div className="relative" ref={notifDropdownRef} title="Notifications">
//                   <button onClick={toggleNotifDropdown}>
//                     <FontAwesomeIcon icon={faBell} size="lg" />
//                     {unreadCount > 0 && (
//                       <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 rounded-full">
//                         {unreadCount}
//                       </span>
//                     )}
//                   </button>

//                   {isNotifDropdownOpen && (
//                     <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-50 border border-gray-200 max-h-96 overflow-y-auto">
//                       <div className="p-3 border-b border-gray-200">
//                         <h3 className="font-semibold text-lg">Notifications</h3>
//                       </div>
                      
//                       {notifications.length === 0 ? (
//                         <div className="p-4 text-center text-gray-500">
//                           No notifications yet
//                         </div>
//                       ) : (
//                         <div className="divide-y divide-gray-100">
//                           {notifications.map((notification) => (
//                             <Link
//                               key={notification._id || notification.id || Math.random()}
//                               to={notification.data?.link || "#"}
//                               className="block px-4 py-3 hover:bg-gray-50"
//                               onClick={() => setIsNotifDropdownOpen(false)}
//                             >
//                               <div className="flex justify-between items-start">
//                                 <div className="flex-1">
//                                   <h4 className="font-medium text-gray-900 text-sm">
//                                     {notification.title}
//                                   </h4>
//                                   <p className="text-xs text-gray-600 mt-1">
//                                     {notification.message}
//                                   </p>
//                                 </div>
//                                 <span className="text-xs text-gray-400 whitespace-nowrap ml-2">
//                                   {formatNotificationTime(notification.createdAt || notification.timestamp || new Date())}
//                                 </span>
//                               </div>
//                             </Link>
//                           ))}
//                         </div>
//                       )}
                      
//                       {notifications.length > 0 && (
//                         <div className="p-3 border-t border-gray-200 text-center">
//                           <Link
//                             to="/notifications"
//                             className="text-blue-600 text-sm font-medium"
//                             onClick={() => setIsNotifDropdownOpen(false)}
//                           >
//                             View all notifications
//                           </Link>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </>
//             )}

//             <button
//               onClick={() => setIsSidebarOpen(true)}
//               className="text-2xl"
//             >
//               <FontAwesomeIcon icon={faBars} />
//             </button>
//           </div>
//         </div>

//         {/* Mobile Search Bar */}
//         <SearchBar isMobile={true} onSearchSubmit={onSearchSubmit} />
//       </div>
//     </div>
//   );
// };

// export default MobileHeader;